import {User} from "../../models/User";
import {TokenManager} from "../TokenManager";
import Hash from "../Hash";
import {ApiClass} from "./ApiClass";
import {API_URL} from "../../constants/CONST";


type errorWithField = {
    field: string | null,
    message: string
}


class UserApiClass extends ApiClass {
    
    async register(name: string, email: string, password: string, country: string): Promise<[boolean, errorWithField | null]> {
        const hashedPassword = Hash(password)
        
        try {
            const res = await fetch(API_URL + "/users/register", {
                method: "POST",
                headers: this.jsonHeader,
                body: JSON.stringify({
                    name,
                    email,
                    password: hashedPassword,
                    country
                })
            })

            const data = await res.json()
    
            if (res.ok) {
                TokenManager.setToken(data.token)
            }
            return [res.ok, data ? (data as errorWithField): null]
        } catch (e) {
            return [false, {message: "An error occured", field: null}]
        }
    }
    

    async login(pseudo: string, password: string): Promise<[boolean, string]> {
        const hashedPassword = Hash(password)
        
        try {
            const res = await fetch(API_URL + "/users/login", {
                method: "POST",
                headers: this.jsonHeader,
                body: JSON.stringify({
                    pseudo,
                    password: hashedPassword
                })
            })
        
            const data = await res.json()
            
            if (res.ok) {
                TokenManager.setToken(data.token)
            }
    
            return [res.ok, data.message ? data.message: ""]
        } catch (e) {
            return [false, "error"]
        }
    }


    async userExist(pseudo: string): Promise<Boolean> {
        try {
            const res = await fetch(API_URL + `/users/exist/${pseudo}`)

            const data = await res.json()

            return data["exist"]
        } catch (e) {
            return false
        }
    }
    
    
    async getConnectedUser(): Promise<User | null> {
        try {
            const res = await fetch(API_URL + "/users/me", {
                method: "GET",
                headers: this.authHeader()
            })

            if (!res.ok) {
                return null
            }
            
            const data = await res.json()
            return new User(data)
        } catch (e) {
            return Promise.reject(e)
        }
    }
    
    
    async updateUserName(name: string): Promise<boolean> {
        try {
            const res = await fetch(API_URL + "/users/me/name", {
                method: "PUT",
                headers: this.authHeader(),
                body: JSON.stringify({
                    name
                })
            })

            return res.ok
        } catch (e) {
            return false
        }
    }
    
    
    async updateCountry(country: string): Promise<boolean> {
        try {            
            const res = await fetch(API_URL + "/users/me/country", {
                method: "PUT",
                headers: this.authHeader(),
                body: JSON.stringify({
                    country
                })
            })

            return res.ok
        } catch (e) {
            return false
        }
    }
    
    
    async updateProfilePicture(file: File): Promise<boolean> {
        try {
            const formData = new FormData()
            formData.append("file", file)
            
            const res = await fetch(API_URL + "/users/me/profilePicture", {
                method: "POST",
                headers: {
                    "Authorization": TokenManager.getToken()
                },
                body: formData
            })

            return res.ok
        } catch (e) {
            return false
        }
    }
    
    
    async updatePassword(actualPassword: string, newPassword: string): Promise<[boolean, number] | null> {
        try {
            const hashedActualPassword = Hash(actualPassword)
            const hashedNewPassword = Hash(newPassword)
            
            const res = await fetch(API_URL + "/users/me/password", {
                method: "PUT",
                headers: this.authHeader(),
                body: JSON.stringify({
                    actualPassword: hashedActualPassword,
                    newPassword: hashedNewPassword
                })
            })
            
            return [res.ok, res.status]
        } catch (e) {
            return null
        }
    }
    
    
    async searchUsers(search: string) {
        try {
            const res = await fetch(API_URL + `/users/search/${search}`, {
                method: "GET",
                headers: this.jsonHeader
            })

            const data = await res.json()
            return data.map((user: any) => new User(user))
        } catch (e) {
            return []
        }
    }
}


export const UserApi = new UserApiClass()
